import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { FormControlLabel, FormGroup, withStyles, Switch } from '@material-ui/core';
import { RootState } from 'state/store';
import { setIsOnScript } from 'state/script.state';
import { green } from '@material-ui/core/colors';

interface FormGroupAttributes {
  $isHidden: boolean;
}

const OnScriptSwitch = withStyles({
  switchBase: {
    '&$checked': {
      color: green[500],
    },
    '&$checked + $track': {
      backgroundColor: green[500],
    },
  },
  checked: {},
  track: {},
})(Switch);

const StyledFormGroup = styled(FormGroup)<FormGroupAttributes>`
  visibility: ${(props) => (props.$isHidden ? 'hidden' : 'visible')};
`;

const OnOffScript = () => {
  const dispatch = useDispatch();
  const isOnScript = useSelector((state: RootState) => state.script.isOnScript);
  const hasCurrentStep = useSelector((state: RootState) => !!state.script.currentStepName);

  const handleChange = () => {
    dispatch(setIsOnScript(!isOnScript));
  };

  // without a current step, a message can only be sent off script, so there's nothing to toggle
  return (
    <StyledFormGroup row $isHidden={!hasCurrentStep}>
      <FormControlLabel
        control={<OnScriptSwitch checked={isOnScript} onChange={handleChange} size="small" />}
        label={isOnScript ? 'On Script' : 'Off Script'}
        labelPlacement="bottom"
      />
    </StyledFormGroup>
  );
};

export default OnOffScript;
